<template>
  <v-app class="m-site">
    <!--    <v-app-bar-->
    <!--      v-if="$vuetify.breakpoint.width > 600"-->
    <!--      style="background-color: #FF7C45"-->
    <!--      elevate-on-scroll-->
    <!--      scroll-target="#content"-->
    <!--      height="50"-->
    <!--    >-->
    <!--      &lt;!&ndash;    the orange guy &ndash;&gt;-->
    <!--      <div class="container">-->
    <!--        <v-row justify="space-between" align="center" class="ml-0">-->
    <!--          <v-col></v-col>-->
    <!--          Interested in Participating in a Clinical Trial?-->
    <!--          <div class="white&#45;&#45;text mx-4 dash"></div>-->
    <!--          <div class="white&#45;&#45;text">-->
    <!--            Help Us Improve Healthcare for Everyone!-->
    <!--          </div>-->
    <!--          <v-col>-->
    <!--            <v-btn-->
    <!--              class="beacon"-->
    <!--              icon-->
    <!--              color="white"-->
    <!--              small-->
    <!--              outlined-->
    <!--              @click="topFormVisible = !topFormVisible"-->
    <!--            >-->
    <!--              <v-icon>mdi-unfold-more-horizontal</v-icon>-->
    <!--            </v-btn>-->
    <!--          </v-col>-->
    <!--          <v-col cols="4"></v-col>-->
    <!--        </v-row>-->
    <!--      </div>-->
    <!--    </v-app-bar>-->
    <v-app-bar
      hidden-md-and-down
      v-if="$vuetify.breakpoint.width > 600 && topFormVisible"
      style="background-color: #ff7c45"
      fixed
      elevate-on-scroll
      scroll-target="#content"
      height="50"
    >
      <div class="container">
        <v-row class="mb-14" style="height: 20px">
          <v-text-field
            solo
            dense
            flat
            background-color="white"
            class="topbar-textfield"
            placeholder="Name"
            v-model="generalForm.name"
          ></v-text-field>
          <v-text-field
            solo
            dense
            flat
            background-color="white"
            placeholder="Phone"
            v-model="generalForm.phone"
            class="topbar-textfield"
          ></v-text-field>
          <v-text-field
            solo
            dense
            flat
            background-color="white"
            placeholder="E-mail"
            v-model="generalForm.email"
            class="topbar-textfield"
          ></v-text-field>
          <v-text-field
            solo
            dense
            flat
            background-color="white"
            placeholder="ZIP Code"
            v-model="generalForm.zip_code"
            class="topbar-textfield"
          ></v-text-field>
          <v-text-field
            solo
            dense
            flat
            background-color="white"
            placeholder="Condition"
            v-model="generalForm.condition"
            class="topbar-textfield"
          ></v-text-field>
          <v-btn
            depressed
            color="#0099dc"
            width="120px"
            class="white--text mr-3 mt-4"
            @click="submitGeneralForm()"
          >
            Submit
          </v-btn>
        </v-row>
      </div>
    </v-app-bar>

    <v-app-bar
      id="top-bar"
      style="background-color: white"
      fixed
      elevate-on-scroll
      scroll-target="#content"
      class="border-bottom-orange"
      :height="
        $store.state.trial_details_route_from !== undefined &&
        this.$route.name !== 'trial_details'
          ? 112
          : 64
      "
    >
      <div style="width: 100%">
        <div
          style="background: #00857c"
          v-if="
            $store.state.trial_details_route_from &&
            this.$route.name !== 'trial_details'
          "
        >
          <v-row style="margin: 0vw 5vw; height: 48px" align="center"
            ><div class="ml-6 white--text">
              <img
                style="padding-right: 12px"
                src="@/assets/arrow_back_up_white.svg"
              /><span
                :style="paragraphTwoFont"
                style="font-family: 'Louis George Café'"
                >Are you lost? Get back to the trial page to pick up where you
                left off.
                <a
                  style="color: #9fffe3; text-decoration: underline"
                  @click="$router.push($store.state.trial_details_route_from)"
                  >Click here</a
                >
              </span>
            </div></v-row
          >
        </div>
        <v-row align="center" style="margin: 0vw 5vw">
          <v-col class="ml-4">
            <img
              @click="$router.push('/')"
              src="./assets/zeda_logo.svg"
              class="m-nav__logo clickable"
              alt=""
            />
          </v-col>

          <v-col cols="2" class="hidden-md-and-up">
            <v-icon size="40" @click="drawer = true">dehaze</v-icon>
          </v-col>
          <v-col
            style="display: flex"
            class="hidden-sm-and-down justify-content-end"
          >
            <v-btn text exact to="/" class="ml-2 mr-0 navigation-button">
              Home
            </v-btn>
            <!--<v-btn
              text
              exact
              to="/about_us"
              class="ml-2 mr-0 navigation-button"
            >
              About Us
            </v-btn>-->
            <!-- <v-btn text exact to="/trials" class="ml-2 mr-0 navigation-button">
              Trials
            </v-btn> -->
            <v-btn
              text
              class="ml-2 mr-0 navigation-button"
              @click="$vuetify.goTo($refs.improve)"
            >
              Contact Us
            </v-btn>
            <!--            <v-btn-->
            <!--              depressed-->
            <!--              color="#0099dc"-->
            <!--              width="120px"-->
            <!--              class="white&#45;&#45;text ml-4"-->
            <!--              href="http://blog.zeda.ai"-->
            <!--            >-->
            <!--              Blog-->
            <!--            </v-btn>-->
          </v-col>
        </v-row>
      </div>
    </v-app-bar>
    <v-dialog fullscreen v-model="drawer">
      <v-card class="h-100">
        <v-card-title>
          <v-layout justify-center class="w-100">
            <v-spacer style="flex-grow: 1.6 !important"></v-spacer>
            <img src="./assets/zeda_logo.svg" class="m-nav__logo" alt="" />
            <v-spacer></v-spacer>
            <v-icon @click="drawer = false" class="close-button">close</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text style="height: calc(100% - 60px)">
          <v-row class="flex-column h-100" align="center" justify="center">
            <v-btn
              rounded
              depressed
              color="primary"
              class="mobile-m-nav__button mb-6"
              exact
              to="/"
              @click="drawer = false"
            >
              Home
            </v-btn>
            <!--<v-btn
              rounded
              depressed
              color="primary"
              class="mobile-m-nav__button mb-6"
              exact
              to="/trials"
            >
              About Us
            </v-btn>-->
            <!-- <v-btn
              rounded
              depressed
              color="primary"
              class="mobile-m-nav__button mb-6"
              exact
              to="/trials"
              @click="drawer = false"
            >
              Trials
            </v-btn> -->
            <v-btn
              rounded
              depressed
              color="primary"
              class="mobile-m-nav__button mb-6"
              @click="
                $vuetify.goTo($refs.improve);
                drawer = false;
              "
            >
              Contact Us
            </v-btn>
            <!--            <v-btn-->
            <!--              rounded-->
            <!--              depressed-->
            <!--              color="primary"-->
            <!--              class="mobile-m-nav__button"-->
            <!--              href="http://blog.zeda.ai"-->
            <!--              drawer="false;"-->
            <!--            >-->
            <!--              Blog-->
            <!--            </v-btn>-->
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div id="content" style="margin-top: 68px"><router-view></router-view></div>
    <div id="footer" v-if="showFooter">
      <section class="bottom" ref="improve">
        <ad-contact @subscribe="snackbar = true"></ad-contact>
      </section>
      <ad-footer style="display: flex; justify-content: center"></ad-footer>
    </div>
  </v-app>
</template>

<script>
import AdContact from "@/components/AdContact";
import AdFooter from "@/components/AdFooter";
export default {
  name: "Site",
  components: { AdFooter, AdContact },
  data() {
    return {
      generalForm: {
        name: "",
        phone: "",
        email: "",
        zip_code: "",
        condition: "",
        type: "general",
      },
      topFormVisible: false,
      drawer: false,
    };
  },
  methods: {
    async submitGeneralForm() {
      this.generalForm.name = this.generalForm.name.trim();
      this.generalForm.email = this.generalForm.email.trim();
      if (this.isValidInput()) {
        try {
          this.submitting = true;
          await this.$store.dispatch("submitContactForm", {
            userData: this.generalForm,
          });
          this.clearUserData();
          this.$notify({
            group: "contactSuccessful",
            title: "Message Sending Successful",
            text: "Thank you. Your message has been sent.",
            duration: 5000,
          });
        } catch (e) {
          this.error = true;
          this.errorMessage = JSON.stringify(e);
          console.log(e);
        } finally {
          this.submitting = false;
        }
      }
    },
    clearUserData() {
      (this.generalForm.name = ""),
        (this.generalForm.phone = ""),
        (this.generalForm.email = ""),
        (this.generalForm.zip_code = ""),
        (this.generalForm.condition = "");
    },
    // notification() {
    //   this.$notify({
    //     group: "submissionSuccesful",
    //     type: "success",
    //     title: "Form Submission Successful",
    //     text: "Thank you. This form has been submission.",
    //     duration: 5000
    //   });
    // },
    async subscribe() {
      this.generalForm.name = this.generalForm.name.trim();
      this.generalForm.email = this.generalForm.email.trim();

      if (this.isValidInput()) {
        try {
          this.submitting = true;
          await this.$store.dispatch("submitContactForm", {
            userData: this.generalForm,
          });
          this.clearUserData();
          this.$notify({
            group: "contactSuccessful",
            title: "Message Sending Successful",
            text: "Thank you. Your message has been sent.",
            duration: 5000,
          });
        } catch (e) {
          this.error = true;
          this.errorMessage = JSON.stringify(e);
          console.log(e);
        } finally {
          this.submitting = false;
        }
      }
    },
    isValidInput() {
      let emailRegex = /^\S+@\S+\.\S+$/;
      if (!emailRegex.test(this.generalForm.email)) {
        this.errorText = "Not a valid email";
        return false;
      }
      if (!/^\w[\w -.]+$/.test(this.generalForm.name)) {
        this.errorText =
          "The name can only contain alphanumeric characters, space, - and .";
        return false;
      }
      return true;
    },
  },
  computed: {
    paragraphTwoFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 12px; line-height: 16px; font-weight: 400;"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 14px; line-height: 20px; font-weight: 400;"; // Small screens (600px and up)
        case "md":
          return "font-size: 14px; line-height: 20px; font-weight: 400;"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 16px; line-height: 25px; font-weight: 400;"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 16px; line-height: 25px; font-weight: 400;"; // Extra large screens (1904px and up)
        default:
          return "font-size: 16px; line-height: 25px; font-weight: 400;";
      }
    },
    showFooter() {
      const excludedRoutes = ["/join-a-trial", "/thank-you-for-interest", "/thank-you/"];
      return !excludedRoutes.includes(this.$route.path);
    },
  },
};
</script>

<style lang="scss">
.v-toolbar__content {
  padding: 0px !important;
}

#footer {
  background-image: url("~@/assets/footer_bg.svg");
  background-size: cover;
  background-position: top right;
  position: relative;
}

.topbar-textfield {
  width: 120px;
  margin: 14px !important;
}

body {
  background-color: #fff;
}
.beacon {
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: #ff7c45;
  height: 3em;
  width: 3em;
  border-radius: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
}
.beacon:before {
  position: absolute;
  content: "";
  height: 1.5em;
  width: 1.5em;
  left: 0.4em;
  top: 0.35em;
  background-color: transparent;
  border-radius: 50%;
  box-shadow: 0px 0px 2px 2px #2980b9;
  -webkit-animation: active 2s infinite linear;
  animation: active 2s infinite linear;
}

.beacon:after {
  position: absolute;
  z-index: 2000;
  content: "";
  height: 1em;
  width: 1em;
  left: 1em;
  top: 1em;
  //background-color:#81baff;
  border-radius: 50%;
}

@-webkit-keyframes active {
  0% {
    -webkit-transform: scale(0.1);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale(2.5);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

@keyframes active {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(2.5);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.dash {
  width: 20px;
  height: 0px;
  left: 394px;
  top: 25px;

  border: 2px solid #ffffff;
  box-sizing: border-box;
}

.container {
  max-width: 1300px;
}

.display-1,
.display-2,
.display-3,
.display-4,
.headline,
.title {
  font-family: "Open Sans", "Helvetica", "Louis George Café", sans-serif !important;
}
.border-bottom-orange {
  border-bottom: 1px solid #f8662bcc !important;
}
.border-bottom-blue {
  border-bottom: 1px solid #0089cb !important;
}

.v-application {
  font-family: "Open Sans", "Roboto", "Helvetica", "Louis George Café",
    sans-serif !important;
}
.m-site {
  background-color: #ffff !important;
}
.m-nav__logo {
  width: 100px;
}
a.btn-primary {
  color: #fff !important;
}
.mobile-m-nav__button {
  width: 200px;
  height: 50px !important;
  text-transform: none !important;
}
.navigation-button {
  height: 40px !important;
  padding: 0.5rem 1rem !important;
  color: #77838f !important;

  &:hover {
    background-color: #377dff10;
    color: #377dff !important;
  }
}
.contact {
  background-color: #f8f8f8;
}
.mobile-m-nav__button {
  width: 200px;
  height: 50px !important;
  text-transform: none !important;
}
</style>
